import React, { useContext } from 'react';
import { BmsContext } from '../../../../App';

const TempProtection = () => {
    const { liveBMSData } = useContext(BmsContext);

    const E3 = liveBMSData?.bmsData?.E3;

    return (
        <div class="overflow-x-auto mt-3 mb-5">
            {liveBMSData && <table class="table table-compact w-full">
                <thead className='text-white'>
                    <tr>
                        <th className='bg-primary text-xs md:text-base'>Project</th>
                        <th className='bg-primary text-xs md:text-base'>Machine</th>
                        <th className='bg-primary text-xs md:text-base'>Setting</th>
                        <th className='bg-primary text-xs md:text-base'>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {/* row 1 --------------------------------------------------*/}
                    <tr>
                        <td className='w-48 md:w-96'><h3 className='md:text-base font-medium whitespace-normal'>Temp Protection</h3></td>
                        <td><h3 className='md:text-base font-medium'>{E3?.tempProtection} °C</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/*------------------------------------------------------- */}

                    {/* row 2 --------------------------------------------------*/}
                    <tr>
                        <td className='w-48 md:w-96'><h3 className='md:text-base font-medium whitespace-normal'>Temp Recovery</h3></td>
                        <td><h3 className='md:text-base font-medium'>{E3?.tempRecovery} °C</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/*------------------------------------------------------- */}

                    {/* row 3 --------------------------------------------------*/}
                    <tr>
                        <td className='w-48 md:w-96'><h3 className='md:text-base font-medium whitespace-normal'>Temp Difference Protection</h3></td>
                        <td><h3 className='md:text-base font-medium'>{E3?.tempDiffProtection} °C</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/*------------------------------------------------------- */}

                    {/* row 4 --------------------------------------------------*/}
                    <tr>
                        <td className='w-48 md:w-96'><h3 className='md:text-base font-medium whitespace-normal'>Battery Charging High Temp Protection</h3></td>
                        <td><h3 className='md:text-base font-medium'>{E3?.chargeOTP} °C</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/*------------------------------------------------------- */}

                    {/* row 5 --------------------------------------------------*/}
                    <tr>
                        <td className='w-48 md:w-96'><h3 className='md:text-base font-medium whitespace-normal'>Battery Discharging High Temp Protection</h3></td>
                        <td><h3 className='md:text-base font-medium'>{E3?.dischargeOTP} °C</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/*------------------------------------------------------- */}

                    {/* row 6 --------------------------------------------------*/}
                    <tr>
                        <td className='w-48 md:w-96'><h3 className='md:text-base font-medium whitespace-normal'>Charge Low Temp Protection</h3></td>
                        <td><h3 className='md:text-base font-medium'> -- °C</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/*------------------------------------------------------- */}

                    {/* row 7 --------------------------------------------------*/}
                    <tr>
                        <td className='w-48 md:w-96'><h3 className='md:text-base font-medium whitespace-normal'>Charge UTPR</h3></td>
                        <td><h3 className='md:text-base font-medium'> {E3?.chargeUTPR.toFixed(2)} °C</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/*------------------------------------------------------- */}

                    {/* row 8 --------------------------------------------------*/}
                    <tr>
                        <td className='w-48 md:w-96'><h3 className='md:text-base font-medium whitespace-normal'>Discharge UTP</h3></td>
                        <td><h3 className='md:text-base font-medium'> {E3?.dischargeUTP.toFixed(2)} °C</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/*------------------------------------------------------- */}

                    {/* row 9 --------------------------------------------------*/}
                    <tr>
                        <td className='w-48 md:w-96'><h3 className='md:text-base font-medium whitespace-normal'>Discharge Cryogenic Protection Recovery</h3></td>
                        <td><h3 className='md:text-base font-medium'> {E3?.dischargeCPR.toFixed(2)} °C</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/*------------------------------------------------------- */}

                    {/* row 10 ------------------------------------------------*/}
                    <tr>
                        <td className='w-48 md:w-96'><h3 className='md:text-base font-medium whitespace-normal'>Power Tube Temperature Protection</h3></td>
                        <td><h3 className='md:text-base font-medium'> {E3?.powerTubeTP} °C</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/*------------------------------------------------------- */}

                    {/* row 11 ------------------------------------------------*/}
                    <tr>
                        <td className='w-48 md:w-96'><h3 className='md:text-base font-medium whitespace-normal'>Power Tube Temperature Recovery</h3></td>
                        <td><h3 className='md:text-base font-medium'> {E3?.powerTubeTR} °C</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/*------------------------------------------------------- */}
                </tbody>
            </table>}
        </div>
    );
};

export default TempProtection;